<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>협회 소개</p></li>
            <li><p>조직도</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>조직도</span>
          </h1>
        </div>
        <div class="page_con">
          <img src="@/assets/static/images/img_organization.svg" alt="" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'about-orgnz-chart-index',
  description: '조직도'
}
</script>

<style scoped></style>
